import type { PlatformAdapter } from './platformAdapter.interface';
import type { AuthPayload, Diagnostics } from '../platform.types';

export class WebAdapter implements PlatformAdapter {
  platform = 'web' as const;

  canDetect(): boolean {
    return true;
  }

  async init(): Promise<void> {
    // noop for web
  }

  async getAuthPayload(): Promise<AuthPayload | null> {
    return { kind: 'web', payload: null };
  }

  getDiagnostics(): Diagnostics {
    return {
      hostname: typeof window !== 'undefined' ? window.location.hostname : null,
      userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : null,
    };
  }

  close(): void {
    if (typeof window === 'undefined') return;
    try {
      window.close();
    } catch {
      // no-op
    }
  }
}
